/** 資本金 */
export const enum CapitalType {
  /** 0: 1000万円以下 */
  _0_under10m,
  /** 1: 5000万円以下 */
  _1_under500m,
  /** 2: 1億円以下 */
  _2_under1000m,
  /** 3: 3億円以下 */
  _3_under3000m,
  /** 4: 5億円以下 */
  _4_under5000m,
  /** 5: 5億円超（大企業分類） */
  _5_upper5000m,
}

export function getCapitalTypeName(value: number | "") {
  if (value === "") {
    return "";
  }
  switch (value) {
    case CapitalType._0_under10m:
      return "1000万円以下";
    case CapitalType._1_under500m:
      return "5000万円以下";
    case CapitalType._2_under1000m:
      return "1億円以下";
    case CapitalType._3_under3000m:
      return "3億円以下";
    case CapitalType._4_under5000m:
      return "5億円以下";
    case CapitalType._5_upper5000m:
      return "5億円超（大企業分類）";

    default:
      return "";
  }
}
